<template>
  <v-container>
    <div class="title-icon top">
      <h1>{{ $t('company.exemption-thanks') }}</h1>
      <v-btn
        icon
        :href="links.application.instructorDispensations"
        target="_blank"
      >
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>
    <p v-if="employee && employee.employed">
      Vi har tagit emot din ansökan om dispens för {{ employee.employed | fullName }} och hör av oss snart.
    </p>
  </v-container>
</template>


<script>
import API from '@/services/api.js'
export default {
  data() {
    return {
      links: require('../../lib/external-links.json'),
      employee: {}
    }
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.employee_id) {
      API.getEmployee(this.$route.params.employee_id)
        .then(res => {
          this.employee = res.data
        })
        .catch(error => {})
    }
  },
  methods: {
    redirectToManuall() {
      window.location.href = 'https://www.byggbranschensyrkesnamnd.se/manual/dispenser'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
